import HeaderCom from "../../components/Header.vue";
import http from "../../api/module";
import pagination from "../../components/pagination";
import { courseURL } from "../../api/baseUrl";

export default {
  name: "trainAudit",
  components: {
    HeaderCom,
    pagination,
  },
  data() {
    return {
      loading: true,
      nowImg: "", //放大查看图片地址
      imgShowBig: false, //图片弹窗显隐
      currentPage: 1, // 当前页
      limit: 20, // 每页显示数量
      total: 0, // 总条目数
      tableData: [],
      formInline: {},
      passValue: [],
      specialList: [],
      batchList: [],
      infoList: [],
      multipleSelection: [], // 表格被选中的内容
      batchDialog: false, // 批量审核
      auditDialog: false, // 单个审核
      photoInfo: [],
      imgInfo: {},
      nopassDialog: false, // 审核不通过
      testInfo: {},
      imgList: [],
      tabList: [],
      nopassBtnDialog: false, // 审核不通过
      studyDialog: false, // 审核不通过
      btrIds: [],
      studyForm: {
        result: "不通过",
        comment: "照片不合格",
      },
      // btnType: 0,  // 测试(学习)照片不通过--确认状态
      id: "",
      empStudyId: "",
      form: {
        result: "不通过",
        comment: "照片不合格",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      passTypeAll: null,
      passTypeItem: null,
      innerVisibleOverTime: false,
      approvalTimeStr: "",
      auditConfFlag: sessionStorage.getItem("auditConfFlag"),
    };
  },
  mounted() {
    this.specialList = JSON.parse(sessionStorage.getItem("specialList"));
    this.batchList = JSON.parse(sessionStorage.getItem("batchList"));
    this.getData();
  },
  methods: {
    //修改审核时间
    auditTime() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          duration: 1000,
          message: "请选择要操作的数据",
          type: "warning",
        });
        return false;
      } else if (this.multipleSelection.length > 1) {
        this.$message({
          duration: 1000,
          message: "最多只能选择一条数据",
          type: "warning",
        });
        this.$refs.multipleTable.clearSelection();
        return false;
      } else {
        this.innerVisibleOverTime = true;
      }
    },
    handleClose() {
      this.innerVisibleOverTime = false;
      this.approvalTimeStr = "";
    },
    //保存修改审核时间
    saveOverTime() {
      if (this.approvalTimeStr == "") {
        this.$message({
          duration: 1000,
          message: "请选择学习时间",
          type: "warning",
        });
        return false;
      }
      let data = {
        btrId: this.multipleSelection[0].btrId,
        approvalTimeStr: this.approvalTimeStr,
      };
      http.updateApprovalTime(data).then((res) => {
        if (res.data.code == 200 || res.data.success) {
          this.$confirm(res.data.message, {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "success",
          });
          this.$refs.multipleTable.clearSelection();
          this.innerVisibleOverTime = false;
          this.approvalTimeStr = "";
          this.getData();
        } else {
          this.$confirm(res.data.message, {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "error",
          });
        }
      });
    },
    //清空图片缓存
    clearChace() {
      this.imgInfo = {};
      this.tabList = [];
    },
    //表格数据转化
    dataTypeFormatter(row) {
      return row.dataType == 0 ? "换证" : "继教";
    },
    //查看图片详情
    checkImgDetail(src) {
      this.nowImg = src;
      this.imgShowBig = true;
    },
    /* 弹框表单清空 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    change(e) {
      // input 视图更新
      this.$forceUpdate();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.limit = val;
      this.getData();
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getData();
    },
    selectionChange(val) {
      // console.log(val, 'val');
      this.multipleSelection = val;
      this.btrIds = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        var item = this.multipleSelection[i];
        var btrId = item.btrId;
        this.btrIds.push(btrId);
      }
    },
    // 批量审核
    batchClick() {
      if (this.multipleSelection.length) {
        this.$confirm("确定批量审核吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            http
              .approvalTrainingRecords({
                recordId: this.btrIds + ",",
                type: 0,
              })
              .then((data) => {
                if (data.data.code == "200" || data.data.success == true) {
                  this.$message({
                    type: "success",
                    duration: 1500,
                    message: "操作成功!",
                  });
                  this.getData();
                } else {
                  this.$message.error({
                    duration: 1000,
                    message: data.data.message,
                  });
                }
              })
              .catch((error) => {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              duration: 1000,
              message: "已取消批量审核!",
            });
          });
      } else {
        this.$message.warning({
          duration: 1500,
          message: "请先选择要审核的数据！",
        });
      }
    },
    // 批量导出
    batchImport() {
      var url = `${courseURL}/trainingRecord/getApprovalEntpTrainingRecord?tokenId=${sessionStorage.getItem(
        "token"
      )}&entpId=${sessionStorage.getItem("entpId")}&export=1&`;
      var data = {
        pageNum: this.currentPage,
        pageSize: this.limit,
        regName: this.formInline.regName,
        regSex: this.formInline.sex,
        regIdcard: this.formInline.idCard,
        certificateNum: this.formInline.certificateNum,
        postId: this.formInline.postId,
        affiliatedEnterprise: this.formInline.affiliatedEnterprise,
        regBatch: this.formInline.batchId,
        dataType: this.formInline.dataType,
        approvalStatus: this.formInline.approvalStatus,
        approvalTimeStrat: this.passValue ? this.passValue[0] : null,
        approvalTimeEnd: this.passValue ? this.passValue[1] : null,
      };
      Object.keys(data).map((key) => {
        if (data[key] != undefined && data[key] != null) {
          url += key + "=" + data[key] + "&";
        }
      });
      window.location.href = url;
    },
    // 获取审核列表信息
    getData() {
      http
        .trainingRecord({
          pageNum: this.currentPage,
          pageSize: this.limit,
          regName: this.formInline.regName,
          regSex: this.formInline.sex,
          regIdcard: this.formInline.idCard,
          certificateNum: this.formInline.certificateNum,
          postId: this.formInline.postId,
          affiliatedEnterprise: this.formInline.affiliatedEnterprise,
          regBatch: this.formInline.batchId,
          dataType: this.formInline.dataType,
          approvalStatus: this.formInline.approvalStatus,
          suspensionType : 0,
          approvalTimeStrat: this.passValue ? this.passValue[0] : null,
          approvalTimeEnd: this.passValue ? this.passValue[1] : null,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.tableData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！",
          });
        });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 13) {
        return row.testStatus == 0 ? "color:#67C23A" : "color:#F56C6C";
      } else if (columnIndex === 14) {
        return row.approvalStatus == 0
          ? "color:#67C23A"
          : row.approvalStatus == "1"
          ? "color:#F56C6C"
          : "color:#409EFF";
      } else {
        return "";
      }
    },
    sexFormat(row) {
      var sex = row.sex;
      return sex == "0" ? "男" : "女";
    },
    resultFormat(row) {
      var testStatus = row.testStatus;
      return testStatus == "0" ? "合格" : "不合格";
    },
    stateFormat(row) {
      var approvalStatus = row.approvalStatus;
      return approvalStatus == "0" ? "通过" : approvalStatus == "1" ? "不通过" : "待审核";
    },
    // 学习状态
    studyFormat(row, column) {
      var state = row.overStatus;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    // 批量通过
    batchBtn() {
      this.$confirm("确定批量审核通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            duration: 1000,
            message: "审核通过成功!",
          });
          setTimeout(() => {
            this.batchDialog = false;
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            duration: 1000,
            message: "已取消审核通过",
          });
        });
    },
    // 单个审核
    auditClick(row) {
      // console.log(row, 'row');
      this.auditDialog = true;
      this.regId = row.regId;
      this.empId = row.empId;
      this.courseId = row.courseId;
      this.btrId = row.btrId;
      this.employeeDetail();
      this.getExerciseRecordImg();
      this.getPhotoList();
    },
    // 根据用户id获取用户信息
    employeeDetail() {
      http
        .employeeDetail({
          empId: this.empId,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.imgInfo = data.data.data;
            this.loading = false;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {});
    },
    // 测试照片列表
    getExerciseRecordImg() {
      http
        .getExerciseRecordImg({
          courseId: this.courseId,
          empId: this.empId,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.testInfo = data.data.data;
            this.id = this.testInfo.id;
            this.imgList = this.testInfo.exerciseMsg.split(",");
            this.tabList = [];
            // console.log(this.imgList, 'imgList');
            this.imgTable = this.imgList.map((item) => {
              var obj = {};
              obj.imgSrc = item;
              if (item != "") {
                this.tabList.push(obj);
              }
              return item;
            });
            // console.log(this.tabList, 'this.tabList');
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {});
    },
    // 学习照片列表
    getPhotoList() {
      http
        .getPhoto({
          regId: this.regId,
          courseId: this.courseId,
          empId: this.empId,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.photoInfo = data.data.data.map((item) => {
              var invalid = item.invalid;
              item.state = invalid === 0 ? "通过" : invalid === 1 ? "不通过" : "待审核";
              var invalidComment = item.invalidComment;
              var cateName = item.cateName;
              var ccName = item.ccName;
              var photoList = item.photoList;
              item.sectionName = cateName + "——" + ccName;
              if (photoList.length) {
                // item.photoUrl = photoList[0].photoUrl;
                // item.createdate = photoList[0].createdate;
              }
              return item;
            });
            for (let i = 0; i < this.photoInfo.length; i++) {
              if (this.photoInfo[i].photoList.length) {
                for (let j = 0; j < this.photoInfo[i].photoList.length; j++) {
                  this.photoInfo[i].photoList[j] = this.photoInfo[i].photoList[j].photoUrl;
                }
              }
            }
            this.photoInfo.forEach((item) => {
              item.minutes = this.isTimeLessThan35Minutes(
                item.courseStudyStart,
                item.courseStudyEnd
              );
            });
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {});
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.minutes) {
        return "warning-row";
      }
    },

    // 判断开始时间和完成时间相差是否小于35分钟
    isTimeLessThan35Minutes(time1, time2) {
      var date1 = new Date(time1).getTime();
      var date2 = new Date(time2).getTime();

      var diff = Math.abs(date1 - date2);
      var minutes = Math.floor(diff / 1000 / 60);

      return minutes < 35;
    },

    //查看图片
    getImgList(photoList, index) {
      let arr = [];
      if (photoList.length == 1) {
        arr.push(photoList[0]);
      } else if (photoList.length == 0) {
        return arr;
      } else {
        for (let i = 0; i < photoList.length; i++) {
          arr.push(photoList[i + index]);
          if (i + index >= photoList.length - 1) {
            index = 0 - (i + 1);
          }
        }
      }
      return arr;
    },
    finishedFormat(row, column) {
      var state = row.courseOver;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    passBtn() {
      this.$confirm("确定审核通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          http
            .approvalTrainingRecords({
              recordId: this.btrId + ",",
              type: 0,
            })
            .then((data) => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message({
                  type: "success",
                  duration: 1000,
                  message: "审核通过成功!",
                });
                this.getPhotoList();
                setTimeout(() => {
                  this.auditDialog = false;
                }, 1000);
                this.getData();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message,
                });
              }
            })
            .catch((error) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            duration: 1000,
            message: "已取消审核通过",
          });
        });
    },
    nopassBtn(type) {
      this.passTypeAll = type;
      // this.auditDialog = false;
      this.nopassDialog = true;
      this.employeeDetail();
      this.getExerciseRecordImg();
      this.getPhotoList();
    },
    // 审核不通过---确认
    nopassSure() {
      let reviewStatus = "";
      if (this.passTypeItem == 1) {
        reviewStatus = 1;
      } else {
        reviewStatus = 0;
      }
      http
        .approvalTrainingRecords({
          recordId: this.btrId + ",",
          type: 1,
          reviewStatus: reviewStatus,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message({
              type: "success",
              duration: 1000,
              message: "审核不通过!",
            });
            setTimeout(() => {
              this.nopassDialog = false;
              this.auditDialog = false;
            }, 1000);
            this.getData();
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
          this.passTypeAll = null;
          this.passTypeItem = null;
        })
        .catch((error) => {});
    },
    // 审核不通过
    nopassClick(type, row) {
      this.passTypeItem = type;
      this.studyDialog = true;
      this.empStudyId = row.empStudyId;
    },
    // 审核不通过---测试照片
    testNopass() {
      this.nopassBtnDialog = true;
    },
    testSure() {
      // console.log('测试照片')
      http
        .approvalExerciseRecord({
          id: this.id,
          exerciseStatus: 1,
          cateCode: this.form.comment,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: "操作成功!",
            });
            this.nopassBtnDialog = false;
            this.getExerciseRecordImg();
          }
        })
        .catch((error) => {});
    },
    // 单个审核不通过---确定
    nopassPop() {
      // console.log('学习照片')
      var comment = this.studyForm.comment;
      if (comment) {
        http
          .setEmpStudyListInvalid({
            comment: comment,
            "empStudyIdList[0]": this.empStudyId,
          })
          .then((data) => {
            if (data.data.code == "200" || data.data.success) {
              this.studyDialog = false;
              this.getPhotoList();
            } else {
              this.$message.error({
                duration: 1000,
                message: data.data.message,
              });
            }
          })
          .catch((error) => {});
      } else {
        this.$message.warning({
          duration: 1000,
          message: "请输入不合格原因!",
        });
        return false;
      }
    },
  },
};
